export default __webpack_public_path__ + "static/media/icon-telecharger_un_dossier.aa0557be.svg";